module.exports = __webpack_public_path__ + "img/big.850175a7.jpg";